import { Button, Form, Mentions, Space } from "antd";
import { useMemo } from "react";

const AddCommentForm = ({ users = [], onSubmit, onCancel, submitText = "Add Comment", placeholder = "Add a comment...", isSubmitting = false }) => {
    const [form] = Form.useForm();
    const userNameToIdMap = useMemo(() => {
        return users
            .filter((user) => user.active && !user.deleted)
            .reduce((acc, user) => {
                const fullName = `${user.firstName} ${user.lastName}`;
                acc[fullName] = user.userId;
                return acc;
            }, {});
    }, [users]);

    const mentionOptions = useMemo(() => {
        return users
            .filter((user) => !user.deleted)
            .map((user) => {
                const fullName = `${user.firstName} ${user.lastName}`;
                return {
                    key: user.userId,
                    value: fullName,
                    disabled: !user.active,
                    label: (
                        <>
                            <span style={{ textDecoration: !user.active ? "line-through" : "none" }}>{fullName}</span>
                            {!user.active && <span style={{ color: "#8c8c8c", marginLeft: "8px" }}>(Inactive)</span>}
                        </>
                    ),
                };
            });
    }, [users]);

    const onFinish = (values) => {
        if (values.content && values.content.trim()) {
            const content = values.content;
            const taggedUserIds = new Set();
            for (const fullName in userNameToIdMap) {
                const mentionRegex = new RegExp(`@${fullName}\\b`, "g");
                if (content.match(mentionRegex)) {
                    taggedUserIds.add(userNameToIdMap[fullName]);
                }
            }
            onSubmit({
                content: content,
                taggedUsers: Array.from(taggedUserIds),
            });
            form.resetFields();
        }
    };

    return (
        <Form form={form} onFinish={onFinish} layout="vertical" style={{ marginBottom: "1rem" }}>
            <Form.Item name="content" rules={[{ required: true, message: "Comment cannot be empty." }]} style={{ marginBottom: "8px" }}>
                <Mentions className="comment-mentions-input" rows={3} placeholder={placeholder} notFoundContent="No users found" options={mentionOptions} />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
                <Space>
                    <Button htmlType="submit" type="primary" loading={isSubmitting} disabled={isSubmitting}>
                        {isSubmitting ? "Adding Comment" : submitText}
                    </Button>
                    {onCancel && <Button onClick={onCancel}>Cancel</Button>}
                </Space>
            </Form.Item>
        </Form>
    );
};

export default AddCommentForm;
